module.exports = __webpack_public_path__ + "static/media/brunch1.b8ce2b37.png";